import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imageSize',
  standalone: true
})
export class ImageSizePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
